// extracted by mini-css-extract-plugin
export default {"editorial":"editorial__fi9fk","h2":"h2__QQyh7","paragraph":"paragraph__l1DsP"};